// ABOUTME: Admin notification service for user approval workflow
// ABOUTME: Sends Telegram alerts for new registrations and login attempts via VPS endpoint

import ErrorHandler from './errorHandler';

class AdminNotificationService {
  /**
   * Notify admin of new user registration
   * @param {string} userEmail - Registered user email
   * @param {string} userId - PocketBase user ID
   */
  static async notifyNewRegistration(userEmail, userId) {
    try {
      console.log(`📧 Sending admin notification for new registration: ${userEmail}`);

      // Call VPS endpoint for Telegram notification (server-side for security)
      const response = await fetch('https://oraculo.buenaar.app/claude/api/admin-notification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'registration',
          userEmail,
          userId
        })
      });

      if (!response.ok) {
        throw new Error(`VPS notification failed: ${response.status}`);
      }

      console.log(`✅ Admin notification sent for ${userEmail}`);

      return { success: true };
    } catch (error) {
      console.error('Admin notification error:', error);

      // Log error but don't fail registration
      await ErrorHandler.captureError(
        ErrorHandler.ERROR_TYPES.SYSTEM,
        `Admin notification failed: ${error.message}`,
        null,
        { userEmail, userId, errorStack: error.stack }
      );

      return { success: false, error: error.message };
    }
  }

  /**
   * Notify admin of login attempt by pending approval user
   * @param {string} userEmail - User email attempting login
   */
  static async notifyPendingLoginAttempt(userEmail) {
    try {
      console.log(`⚠️ Sending admin reminder for pending user login: ${userEmail}`);

      // Call VPS endpoint for Telegram notification (server-side for security)
      const response = await fetch('https://oraculo.buenaar.app/claude/api/admin-notification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'login-attempt',
          userEmail,
          userId: null
        })
      });

      if (!response.ok) {
        throw new Error(`VPS notification failed: ${response.status}`);
      }

      console.log(`✅ Admin reminder sent for ${userEmail}`);

      return { success: true };
    } catch (error) {
      console.error('Admin login reminder error:', error);

      // Log error but don't fail login flow
      await ErrorHandler.captureError(
        ErrorHandler.ERROR_TYPES.SYSTEM,
        `Admin login reminder failed: ${error.message}`,
        null,
        { userEmail, errorStack: error.stack }
      );

      return { success: false, error: error.message };
    }
  }

  // TODO: Future enhancement - Email notifications when VPS email service is extended
  // static async sendAdminEmail(userEmail, userId, timestamp) { ... }
}

export default AdminNotificationService;
